import React from "react";
import { Link } from "./style";

const getClassNames = (hidden = [], cl, field) => {
  let className = "";
  if (hidden.includes(field)) className += "hidden-xs ";
  if (cl) className += cl;
  return className;
};

const Table = ({
  tableHeaders = [],
  tableData = [],
  fields = [{ name: "", icon: "" }],
  hideFieldsXs = [],
  remove,
  onRemove,
}) => (
  <>
    <table cellSpacing="0" cellPadding="0" className="table">
      <thead>
        <tr>
          {tableHeaders.map((h) => (
            <th className={`bdl_radius ${h.class}`}>{h.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.map((h) => (
          <tr>
            {fields.map((f) => (
              <td className={getClassNames(hideFieldsXs, f?.class, f?.name)}>
                {h[f.name]}
              </td>
            ))}
            {remove && (
              <td>
                <Link className="fa fa-trash" onClick={onRemove} />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

export default Table;
